import { TextInput, useGetIdentity, useGetOne, useTranslate } from 'react-admin'
import FormCard from '../inputFormComponents/FormCard'
import FormRow from '../inputFormComponents/FormRow'
import { InvoiceType, TextModel } from '../GeneratedClients/FreeBillApi'
import { useState } from 'react'
import RadioButtonTextModel from './RadioButtonTextModel'

interface IProps {
  initConfigTextModel?: "show" | "hide"
  textModel?: TextModel
  hideAction?: boolean
  invoiceType?: InvoiceType
  cardNumber?: number
  description?: JSX.Element
}

const FormCardTextModel = ({initConfigTextModel, textModel, hideAction, invoiceType, cardNumber, description}: IProps) => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const [ configTextModel, setConfigTextModel] = useState<"show" | "hide" | undefined>(initConfigTextModel)
  const translate = useTranslate()
  if(identityLoading || userLoading || !identity) return null

  const rows = [
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModel.introduction" label="resources.textTemplates.introduction" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModel.terms" label="resources.textTemplates.terms" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModel.ending" label="resources.textTemplates.ending" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModel.deliveryDateNotice" label="resources.textTemplates.deliveryDateNotice" />,
    ]} />
  ]

  user.isSmallBusiness && rows.push(
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModel.isSmallBusinessNotice" label="resources.textTemplates.isSmallBusinessNotice" />,
    ]} />
  )

  if(!invoiceType ||
  invoiceType === InvoiceType.Revenues13bInvoice ||
  invoiceType === InvoiceType.EuInvoiceDelivery ||
  invoiceType === InvoiceType.EuInvoiceService ||
  invoiceType === InvoiceType.ThirdCountryInvoiceDelivery ||
  invoiceType === InvoiceType.ThirdCountryInvoiceService)
  {
    rows.push(
      <FormRow fields={[
        <TextInput fullWidth multiline helperText={false} source="textModel.reverseChargeNotice" label="resources.textTemplates.reverseChargeNotice" />,
      ]} />
    )
  }

  return (
    <FormCard
      cardNumber={cardNumber} 
      description={description}
      action={!hideAction ? <RadioButtonTextModel setShowTextModel={setConfigTextModel} textModel={textModel} /> : undefined }
      title={translate("resources.textTemplates.name", {smart_count: 2})} 
      rows={configTextModel === "show" ? rows : undefined}
    />
  )
}

export default FormCardTextModel